import ComingSoon from "./ComingSoon.presenter";
export default ComingSoon;
